import { FiEdit } from "react-icons/fi";
import { FaExternalLinkAlt } from "react-icons/fa";
import "../../style/scss/App.scss";

function employerId(employer) {
  return Number(employer?.ID ?? employer?.id ?? 0) || 0;
}

/** Open same-origin route in a new tab without stripping sessionStorage (auth). */
function openAppTab(path) {
  // Do not use <a target="_blank" rel="noreferrer"> — that tab starts with empty
  // sessionStorage, so App loads logged-out and redirects to marketing.
  window.open(path, "_blank");
}

export default function EmployerListItem({ employer, onSelect, onEdit }) {
  if (!employer) return null;

  const id = employerId(employer);
  const name = employer.Name ?? employer.name ?? "";
  const shortName = employer.ShortName ?? employer.shortName ?? "";
  const description = employer.Description ?? employer.description ?? "";
  const url = employer.Url ?? employer.url ?? "";
  const roles = employer.EmployerAdminRoles || [];
  const hasAdminRoles = roles.length > 0;
  const viewPath = `/employerView/${id}`;
  const byline = [shortName && shortName !== name ? shortName : null, description]
    .filter(Boolean)
    .join(" — ");
  const selectable = typeof onSelect === "function";

  function handlePanelClick() {
    if (selectable) {
      onSelect(employer);
      return;
    }
    if (id > 0) {
      openAppTab(viewPath);
    }
  }

  function stopRowSelect(e) {
    e.stopPropagation();
  }

  function handleEdit(e) {
    stopRowSelect(e);
    if (hasAdminRoles) {
      openAppTab(`/employerAdminEdit/${id}`);
      return;
    }
    if (typeof onEdit === "function") {
      onEdit(id);
      return;
    }
    openAppTab(`/employerEdit/${id}`);
  }

  return (
    <li title={`${id}. ${name}`} className="listItem employer-select-item">
      <div
        className="Job mobilePanel"
        role="button"
        tabIndex={0}
        onClick={handlePanelClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handlePanelClick();
          }
        }}
      >
        {selectable && id > 0 ? (
          <span className="rightIcons" onClick={stopRowSelect}>
            <button
              type="button"
              className="employer-select-action"
              title="View employer details"
              aria-label={`View ${name}`}
              onClick={(e) => {
                stopRowSelect(e);
                openAppTab(viewPath);
              }}
            >
              <FaExternalLinkAlt size={16} aria-hidden />
            </button>
            <button
              type="button"
              className="employer-select-action"
              title="Edit employer"
              aria-label={`Edit ${name}`}
              onClick={handleEdit}
            >
              <FiEdit size={16} aria-hidden />
            </button>
          </span>
        ) : null}
        <span className="title">{name}</span>
        {byline ? <span className="byline">{byline}</span> : null}
        {url ? <span className="rightText">{url}</span> : null}
      </div>
    </li>
  );
}
